import React, { useState, useEffect, lazy } from "react";
import {
  Route,
  Switch,
  Redirect,
  useLocation,
  useHistory,
} from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Nav, PrivateRoute, Alert } from "@/_components";

// Lazy load all components that allow it.
const HomePage = lazy(() => import("../home/HomePage"));
const ProfilePage = lazy(() => import("../profile/ProfilePage"));
const ResourcesPage = lazy(() => import("../resources/ResourcesPage"));
const HelpPage = lazy(() => import("../help/HelpPage"));
const FAQPage = lazy(() => import("../faq/FAQPage"));
import Account from "../account/Index";
import Register from "../Register/Register";
import Cookies from "universal-cookie";
import moment from "moment-timezone";
function setCountryCode(location) {
  // TODO: for local aus testing. remove once verified.
  // sessionStorage.setItem("LSCountryCode", "AU");
  //
  let hostname = location.hostname.split(".");
  if (
    hostname[hostname.length - 1] === "au" ||
    process.env.REACT_APP_ENV === "ausdev" ||
    process.env.REACT_APP_ENV === "austest" ||
    process.env.REACT_APP_ENV === "ausprod"
  )
    sessionStorage.setItem("LSCountryCode", "AU");
  else sessionStorage.setItem("LSCountryCode", "USA");
}
function setTestInput(location) {
  let cookies = new Cookies();
  const user = cookies.get("driveSaferUser");
  let { hostname } = location;
  if (
    hostname.includes("dev") ||
    hostname.includes("localhost") ||
    hostname.includes("test") ||
    (user !== null && user !== undefined && user.isTest === true)
  )
    cookies.set("lsEnrollmentEntryType", "Test", {
      path: "/",
      sameSite: "strict",
      expires: new Date(moment().add(1, "h").format()),
    });
}
const theme = createTheme({
  palette: {
    primary: {
      light: "#495d7e",
      main: "#1c355e",
      dark: "#132541",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ffffff",
      main: "#ffffff",
      dark: "#ffffff",
      contrastText: "#1c355e",
    },
  },
});
theme.typography.h6 = {
  fontSize: "1.1rem",
  [theme.breakpoints.down("lg")]: {
    fontSize: ".97rem",
  },
};
function App() {
  const { pathname } = useLocation();
  const [, setNotifyAlert] = useState(0);
  const [selected, setSelected] = useState();
  const [locationKeys, setLocationKeys] = useState([]);
  const history = useHistory();
  useEffect(() => {
    setTestInput(window.location);
    setCountryCode(window.location);
    setSelected(window.location.pathname);
    return history.listen((location) => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
      }
      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([, ...keys]) => keys);
          setSelected(window.location.pathname);
        } else {
          setLocationKeys((keys) => [location.key, ...keys]);
          setSelected(window.location.pathname);
        }
      }
    });
  }, [locationKeys]);
  const handleNotifyUpdate = (unreadNotifications) => {
    setNotifyAlert(unreadNotifications);
  };
  const handleNavUpdate = (index) => {
    setSelected(index);
  };
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div
          style={{
            display: "flex",
          }}
        >
          <Nav selectedNav={selected} updateSelected={handleNavUpdate} />
          <Alert />
          <Switch>
            <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
            <PrivateRoute
              exact
              path="/"
              component={HomePage}
              onNotificationsUpdate={handleNotifyUpdate}
              updateSelectedNav={handleNavUpdate}
              suspense={true}
            />
            <PrivateRoute
              path="/profile"
              component={ProfilePage}
              suspense={true}
              onNotificationsUpdate={handleNotifyUpdate}
            />
            <PrivateRoute
              path="/resources"
              component={ResourcesPage}
              onNotificationsUpdate={handleNotifyUpdate}
              suspense={true}
            />
            <PrivateRoute
              path="/help"
              component={HelpPage}
              onNotificationsUpdate={handleNotifyUpdate}
              suspense={true}
            />
            <PrivateRoute
              path="/faq/:id?"
              component={FAQPage}
              suspense={true}
            />
            <Route path="/account" component={Account} />
            <Route path="/register" component={Register} />

            <Redirect from="*" to="/" />
          </Switch>
          <ToastContainer autoClose={4000} hideProgressBar />
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
export { App };
